var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_494)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19198 1.154L18.012 1.148V5.754L6.19198 5.76C5.65811 5.7606 5.13807 5.59029 4.70798 5.274L2.79198 3.86C2.72912 3.8135 2.67804 3.75291 2.64284 3.6831C2.60764 3.61328 2.5893 3.53618 2.5893 3.458C2.5893 3.37981 2.60764 3.30271 2.64284 3.23289C2.67804 3.16308 2.72912 3.10249 2.79198 3.056L4.70998 1.64C5.13872 1.3238 5.65726 1.15282 6.18998 1.152L6.19198 1.154ZM22.878 5.75L20.512 5.752V1.146H22.886C24.154 1.166 25.124 2.292 25.124 3.446C25.124 4.602 24.154 5.73 22.886 5.75H22.878ZM11.016 10.37C11.686 10.638 12.256 10.932 12.75 11.224V28C11.9878 27.4273 11.1541 26.9566 10.27 26.6C8.79998 26.012 6.67998 25.526 3.44598 25.526C3.18077 25.526 2.92641 25.4206 2.73888 25.2331C2.55134 25.0456 2.44598 24.7912 2.44598 24.526V10.15C2.44598 9.88478 2.55134 9.63043 2.73888 9.44289C2.92641 9.25535 3.18077 9.15 3.44598 9.15C6.88598 9.15 9.26598 9.668 11.016 10.37ZM17.728 26.6C16.648 27.034 15.89 27.532 15.248 27.998V11.224C15.742 10.932 16.314 10.638 16.984 10.37C18.734 9.668 21.114 9.15 24.554 9.15C24.8192 9.15 25.0736 9.25535 25.2611 9.44289C25.4486 9.63043 25.554 9.88478 25.554 10.15V24.526C25.554 24.7912 25.4486 25.0456 25.2611 25.2331C25.0736 25.4206 24.8192 25.526 24.554 25.526C21.32 25.526 19.2 26.01 17.728 26.6Z",
    fill: "#B28A4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.4090447e60c622948d3bf244493f34fb.svg";
export { ForwardRef as ReactComponent };